var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.41,
    y: 60.85,
    width: 26.48,
    height: 11.19,
    transform: "translate(881.29 132.88) rotate(-180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.18,
    y: 46.74,
    width: 26.48,
    height: 11.19,
    transform: "translate(910.84 104.66) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.14,
    y: 229.02,
    width: 26.48,
    height: 11.19,
    transform: "translate(240.77 469.23) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.92,
    y: 214.91,
    width: 26.48,
    height: 11.19,
    transform: "translate(270.31 441.01) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.63,
    y: 229.02,
    width: 26.48,
    height: 11.19,
    transform: "translate(299.74 469.23) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.34,
    y: 46.74,
    width: 26.48,
    height: 11.19,
    transform: "translate(89.16 104.66) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.11,
    y: 329.85,
    width: 26.48,
    height: 11.19,
    transform: "translate(118.71 670.89) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.34,
    y: 315.74,
    width: 26.48,
    height: 11.19,
    transform: "translate(89.16 642.67) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.41,
    y: 329.85,
    width: 26.48,
    height: 11.19,
    transform: "translate(881.29 670.89) rotate(-180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.17,
    y: 73.17,
    width: 78.58,
    height: 95.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.15,
    y: 81.87,
    width: 60.62,
    height: 77.92,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.15,
    y: 81.87,
    width: 2.37,
    height: 77.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.75,
    y: 73.17,
    width: 2.37,
    height: 95.31,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.31,
    y: 99.54,
    width: 14.29,
    height: 42.59,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,131.76H307.9V109.9H347Zm-38.12-1H346V110.9H308.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.84,
    y: 191.45,
    width: 78.58,
    height: 95.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.81,
    y: 200.15,
    width: 60.62,
    height: 77.92,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.81,
    y: 200.15,
    width: 2.37,
    height: 77.92,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.41,
    y: 191.45,
    width: 2.37,
    height: 95.31,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.26,
    y: 220.29,
    width: 12.25,
    height: 30.96,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.07,261H388.18V238.61h33.89Zm-32.89-1h31.89V239.61H389.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.67,
    y: 117.96,
    width: 174.64,
    height: 7.66,
    transform: "translate(281.97 243.57) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.86,
    y: 125.62,
    width: 7.66,
    height: 25.33,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.86,
    y: 125.62,
    width: 7.66,
    height: 7.83,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.45,
    y: 125.62,
    width: 7.66,
    height: 25.33,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.45,
    y: 125.62,
    width: 7.66,
    height: 7.83,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.16,
    y: 87.41,
    width: 48.81,
    height: 12.29,
    transform: "translate(283.12 -96.01) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.88,
    y: 63.07,
    width: 5.36,
    height: 12.29,
    transform: "translate(258.78 -120.34) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.57,
    y: 73.62,
    width: 1.99,
    height: 12.29,
    transform: "translate(269.33 -109.79) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.12,
    y: 101.96,
    width: 5.36,
    height: 13.82,
    transform: "translate(297.67 -79.92) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.65,
    y: 85.19,
    width: 56.94,
    height: 8.59,
    transform: "translate(268.61 -89.63) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.21,
    y: 74.75,
    width: 21.9,
    height: 5.15,
    transform: "translate(256.48 -101.84) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.51,
    y: 90.6,
    width: 56.94,
    height: 8.59,
    transform: "translate(301.11 66.1) rotate(135.33)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.05,
    y: 95.23,
    width: 21.9,
    height: 5.16,
    transform: "translate(298.06 73.16) rotate(135.33)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.92,
    y: 89.05,
    width: 43.25,
    height: 14.59,
    transform: "translate(263.88 -71.2) rotate(90)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.52,
    y: 104.07,
    width: 4.03,
    height: 14.59,
    transform: "translate(278.91 -56.17) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.76,
    y: 98.63,
    width: 1.56,
    height: 14.59,
    transform: "translate(273.46 -61.62) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.43,
    y: 92.61,
    width: 40.64,
    height: 10.08,
    transform: "translate(298.39 -103.1) rotate(90)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 106.73,
    width: 3.79,
    height: 10.08,
    transform: "translate(312.51 -88.98) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.85,
    y: 82.56,
    width: 3.79,
    height: 10.08,
    transform: "translate(288.34 -113.15) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.01,
    y: 87.78,
    width: 1.47,
    height: 10.08,
    transform: "translate(293.57 -107.93) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,65.89c8.6,8.42,10,21.44,8.23,32.84,0,.26-.45.19-.45,0,0-2.6.08-5.17.07-7.73,0-.12-.08-.23-.13-.35a17.28,17.28,0,0,1-5.59-6c-1.43-2.82-2-6-3.09-9-.11-.28.19-.2.39,0,5.23,3.85,6.9,8,8.4,13.55a45.91,45.91,0,0,0-.91-8.63,29.46,29.46,0,0,0-7.15-14.39C88.61,66,88.83,65.74,89,65.89Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.36,66.87c-1.47,0-2.4,2.42-3.55,3.11a1.12,1.12,0,0,1-1.64-.26c-1.14-1.59.43-3.56,1.9-4.66A16.92,16.92,0,0,1,81,66.47a1.08,1.08,0,0,1-1.39-.83c-.5-2.17,2.23-3.14,4.1-3.18-.91-.63-3.5-2.35-2.12-3.19S86,60.87,87,61.68c1.46,1.19,3.2,3,3.27,4.81C90.4,68.66,88.5,67.33,87.36,66.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.79,67.24c-1.89-.86-5.52.38-5.83-.34-.63-1.46,2.28-2.46,3.84-2.65-1.44-.39-4.2-1-4.12-2.4.1-1.7,4.24-.24,6.34,1.36,2.63,2,2.62,4,2.18,4.37C89.6,68.11,88.1,67.38,87.79,67.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.56,65.06c-8.91,8.08-10.85,21-9.47,32.5,0,.26.44.21.45,0,.1-2.6.11-5.17.22-7.73l.15-.34a17.39,17.39,0,0,0,5.81-5.79c1.54-2.77,2.22-5.93,3.43-8.83.12-.28-.19-.21-.39-.07-5.37,3.65-7.2,7.74-8.91,13.22a46,46,0,0,1,1.24-8.59,29.43,29.43,0,0,1,7.69-14.11C108.92,65.15,108.71,64.92,108.56,65.06Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.14,66.1c1.47.11,2.31,2.5,3.43,3.24a1.12,1.12,0,0,0,1.65-.2c1.2-1.55-.29-3.57-1.72-4.73a16,16,0,0,0,3,1.53,1.07,1.07,0,0,0,1.42-.78c.58-2.15-2.11-3.22-4-3.33.93-.6,3.59-2.21,2.24-3.11s-4.51,1.44-5.53,2.2c-1.51,1.13-3.32,2.84-3.45,4.69C107,67.77,109,66.51,110.14,66.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.69,66.45c1.93-.79,5.51.59,5.85-.12.68-1.43-2.19-2.54-3.74-2.79,1.45-.34,4.24-.85,4.21-2.25,0-1.7-4.23-.4-6.38,1.13-2.72,1.92-2.78,3.87-2.35,4.28C107.85,67.26,109.38,66.58,109.69,66.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.45,86.41a88.44,88.44,0,0,1-2.77,12.78.32.32,0,0,1-.62-.13c.58-3.94,1.65-7.8,2.24-11.74A59.4,59.4,0,0,0,99,75.26c-.38-6.63-2.18-13.69-6.51-18.89-.09-.12.11-.29.21-.18C101.35,66.3,100,78.7,100,79.81c1.23-4.19,2.49-9,7.14-13.25.2-.18.35-.09.32.22-.83,7.76-3,11.81-7.49,16C99.8,84,99.64,85.2,99.45,86.41Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.39,57.54c-1.56-.7-3.71,1.29-5.25,1.42a1.28,1.28,0,0,1-1.57-1.08c-.38-2.23,2.24-3.48,4.32-3.88-1.31-.08-2.6.27-3.89-.08a1.24,1.24,0,0,1-1-1.56c.58-2.51,3.89-2.14,5.86-1.24-.63-1.11-2.46-4.2-.61-4.38S94,50.65,94.67,52c.92,2,1.84,4.69,1,6.65C94.64,60.92,93.35,58.58,92.39,57.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.65,58.13c-1.53-1.84-5.92-2.39-5.88-3.29.09-1.82,3.6-1.4,5.32-.81-1.3-1.13-3.85-3.17-3.06-4.57,1-1.71,4.52,1.89,5.88,4.61,1.72,3.42.72,5.44.07,5.62C94.09,60,92.91,58.43,92.65,58.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.15,88.74,109,118H85.71c.47-2.59,4.81-29.25,4.81-29.25Z",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-25"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 362.17,
    cy: 446.26,
    rx: 89.61,
    ry: 10.79,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "453.01 420.55 402.26 420.79 351.5 420.88 250 421.05 148.5 420.88 97.74 420.79 46.99 420.55 97.74 420.3 148.5 420.21 250 420.05 351.5 420.21 402.26 420.3 453.01 420.55",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-25"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 281.55,
    cy: 268.45,
    r: 3.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.54,
    cy: 268.45,
    r: 3.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.53,
    cy: 268.45,
    r: 3.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.81,228.25C245,268.52,301.18,362.07,308.52,376.66c5,9.91-46.78,37.38-49.15,30.15-3-9.26-56.05-107.45-68.7-162.77C185.13,219.81,195.49,220.12,203.81,228.25Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.76,400c1.93,4.94,8.58,26,13,28.53s27.19,1.5,38.68,1.26,13.68-3.49,13.41-7.44-24.4-4.2-24.4-4.2S329.82,426.69,338,428s26.89,5.66,29.45-1.11c1.16-3.06-4-6-4-6s7.88,2.12,9-1.8c1.33-4.46-4.95-6.77-4.95-6.77s4.92.89,4.95-2.73c.09-8.07-30.62-11.4-30.62-11.4s23.69,10.93,24.3,4.33c.86-9.14-47.41-18.13-52.49-22a34.13,34.13,0,0,1-8.23-9.72Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.7,424.34a3.52,3.52,0,0,0-1.16-3,9.91,9.91,0,0,0-2.84-1.76,37.55,37.55,0,0,0-6.62-2c-4.56-1-9.21-1.77-13.86-2.87a56.29,56.29,0,0,1,14.22,1.3,26,26,0,0,1,6.83,2.45,9.07,9.07,0,0,1,2.87,2.37A3.67,3.67,0,0,1,321.7,424.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.38,420.9c-3.33-.74-6.61-1.61-9.89-2.48s-6.54-1.81-9.81-2.72l-9.76-2.84c-3.25-.94-6.51-1.88-9.8-2.78a74.71,74.71,0,0,1,10.1,1.58c3.34.69,6.63,1.57,9.91,2.49s6.51,2,9.72,3.09S360.26,419.53,363.38,420.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.73,401.87a64.74,64.74,0,0,1,9.32,1.09,87.2,87.2,0,0,1,9.14,2.15,84.51,84.51,0,0,1,8.86,3.1,66.92,66.92,0,0,1,8.42,4.12c-3-1-5.89-2-8.85-2.95s-5.91-1.88-8.88-2.72-6-1.68-9-2.49S334.77,402.63,331.73,401.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.31,394.09a62.38,62.38,0,0,1,28.59,9.11c-4.8-1.59-9.46-3.29-14.23-4.77S341.15,395.53,336.31,394.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.46,369.56,246.79,406s-50-124.41-56.46-157,5.3-33.73,24.19-13.66C236.61,258.82,307.46,369.56,307.46,369.56Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,390.67c4.56-2.18,8.85-5,13.17-7.65s8.49-5.21,12.72-7.86c8.52-5.33,17.24-10.5,25.4-16.39a.19.19,0,0,0-.19-.32c-9.08,4.51-17.73,10-26.36,15.31q-6.48,4-12.86,8.19a132.09,132.09,0,0,0-12.12,8.41C245.6,390.51,245.83,390.76,246,390.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.29,379.1a3.64,3.64,0,0,0-2.32,3.31,2.81,2.81,0,0,1-1.29,2.41,3.05,3.05,0,0,1-1.48.48c-.58.1-1.18.18-1.78.34,1.18.2,2.37.67,3.74.14a3.65,3.65,0,0,0,2.22-3.36,2.74,2.74,0,0,1,1.36-2.33,3.12,3.12,0,0,1,1.5-.45c.59-.1,1.19-.18,1.78-.33C248.83,379.1,247.7,378.64,246.29,379.1Zm37.33-46.2a3.63,3.63,0,0,0-1.19,2.61,2.82,2.82,0,0,1-1.28,2.41,3.13,3.13,0,0,1-1.49.48c-.58.1-1.18.18-1.78.34,1.19.2,2.37.67,3.74.14a3.64,3.64,0,0,0,2.22-3.36,2.53,2.53,0,0,1,.5-1.53Zm-42.33-4.26A3.61,3.61,0,0,0,239,332a2.83,2.83,0,0,1-1.29,2.41,3.09,3.09,0,0,1-1.48.48c-.59.1-1.18.18-1.78.34,1.18.2,2.36.67,3.74.14a3.63,3.63,0,0,0,2.21-3.36,2.79,2.79,0,0,1,1.36-2.33,3.19,3.19,0,0,1,1.5-.45c.6-.1,1.2-.18,1.78-.33C243.83,328.64,242.69,328.18,241.29,328.64Zm-.25-43a3.58,3.58,0,0,0-3.92.8,2.8,2.8,0,0,1-2.63.69,3,3,0,0,1-1.36-.76c-.5-.35-1-.7-1.51-1,.7,1,1.18,2.13,2.51,2.78a3.58,3.58,0,0,0,4-.68,2.79,2.79,0,0,1,2.61-.8,2.86,2.86,0,0,1,1.38.71c.49.34,1,.7,1.5,1C242.9,287.39,242.4,286.21,241,285.63Zm-22.76-22.32a3.63,3.63,0,0,0-3.35-2.2,2.75,2.75,0,0,1-2.35-1.37,3,3,0,0,1-.42-1.5c-.13-.6-.19-1.18-.36-1.78-.18,1.18-.66,2.33-.18,3.74a3.58,3.58,0,0,0,3.28,2.32,2.86,2.86,0,0,1,2.89,2.75c.12.6.18,1.18.34,1.78C218.33,265.9,218.82,264.69,218.28,263.31Zm79.84,109.06a3.57,3.57,0,0,0-3.34-2.2,2.81,2.81,0,0,1-2.35-1.36,3.32,3.32,0,0,1-.43-1.53c-.12-.56-.18-1.16-.33-1.76-.21,1.18-.69,2.32-.21,3.72a3.55,3.55,0,0,0,3.29,2.32,2.81,2.81,0,0,1,2.41,1.31,2.77,2.77,0,0,1,.5,1.46c.06.34.11.67.17,1l.36-.22A4.48,4.48,0,0,0,298.12,372.37ZM266.64,311a3.58,3.58,0,0,0-3.34-2.2,2.8,2.8,0,0,1-2.35-1.36,3.1,3.1,0,0,1-.43-1.53c-.12-.57-.18-1.16-.33-1.76-.21,1.18-.69,2.32-.21,3.72a3.55,3.55,0,0,0,3.29,2.32,2.93,2.93,0,0,1,2.9,2.77c.11.6.18,1.2.33,1.77C266.7,313.56,267.19,312.38,266.64,311Zm-51.39-1.24a3.6,3.6,0,0,0-3.34-2.2,2.77,2.77,0,0,1-2.35-1.36,3.09,3.09,0,0,1-.43-1.52c-.12-.57-.18-1.17-.33-1.77a10.91,10.91,0,0,0-.41,2.78,4.37,4.37,0,0,0,.2.95,3.3,3.3,0,0,0,.46.87,3.65,3.65,0,0,0,2.83,1.45,2.93,2.93,0,0,1,2.9,2.76c.11.6.18,1.2.33,1.77C215.31,312.33,215.8,311.14,215.25,309.75Zm50.25,49.91a3.6,3.6,0,0,0-3.33-2.2,2.78,2.78,0,0,1-2.34-1.36,3.13,3.13,0,0,1-.45-1.51c-.1-.58-.18-1.18-.34-1.77-.19,1.17-.66,2.32-.19,3.73a3.55,3.55,0,0,0,3.3,2.3,2.9,2.9,0,0,1,2.41,1.31,2.71,2.71,0,0,1,.46,1.48c.14.58.2,1.16.35,1.76C265.58,362.24,266.06,361.05,265.5,359.66ZM191,239.23a3.38,3.38,0,0,0-2.22-.23c0,.44.09.88.14,1.34a3,3,0,0,1,1.71-.1A3.2,3.2,0,0,1,192,241c.49.33.95.71,1.48,1C192.82,241,192.34,239.9,191,239.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.55,390.51,246.79,406s-50-124.41-56.46-157c-3.13-15.77-2-24.18,2.17-26.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.11,420.75H61C58.67,418,89.53,272.2,154.86,226.35c20.74-14.55,47.31-8.47,51.74,9.43C225.49,312.2,223.24,418.3,221.11,420.75Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.88,256.66a3.61,3.61,0,0,0-2.32,3.3,2.78,2.78,0,0,1-1.29,2.41,3,3,0,0,1-1.48.48c-.58.11-1.18.18-1.78.35,1.18.19,2.37.67,3.74.13A3.64,3.64,0,0,0,162,260a2.73,2.73,0,0,1,1.36-2.33,3,3,0,0,1,1.49-.45c.6-.11,1.2-.18,1.79-.33C165.42,256.66,164.29,256.19,162.88,256.66Zm-11.45,77.58a3.57,3.57,0,0,0-2.32,3.27,2.84,2.84,0,0,1-1.27,2.43,3.13,3.13,0,0,1-1.49.48c-.59.1-1.17.18-1.77.34,1.17.19,2.35.67,3.74.13a3.64,3.64,0,0,0,2.19-3.35,2.81,2.81,0,0,1,1.37-2.33,3,3,0,0,1,1.51-.44c.6-.11,1.17-.19,1.77-.34C154,334.24,152.84,333.76,151.43,334.24Zm69.77,73.27a2.84,2.84,0,0,1-1.49.48c-.59.12-1.17.18-1.77.35,1.17.19,2.35.68,3.74.15a2.77,2.77,0,0,0,.54-.28c0-.66.05-1.35.07-2.06A2.87,2.87,0,0,1,221.2,407.51Zm-97.53-14.35a3.52,3.52,0,0,0-2.32,3.28,2.82,2.82,0,0,1-1.29,2.41,2.9,2.9,0,0,1-1.48.49c-.59.11-1.18.18-1.77.35,1.15.19,2.34.67,3.73.13a3.62,3.62,0,0,0,2.2-3.35,2.86,2.86,0,0,1,1.36-2.35,3.05,3.05,0,0,1,1.53-.42c.58-.13,1.16-.19,1.75-.34C126.21,393.16,125.07,392.67,123.67,393.16Zm71.38-114.73a3.56,3.56,0,0,0-2.32,3.29,2.78,2.78,0,0,1-1.29,2.41,2.89,2.89,0,0,1-1.46.49c-.6.1-1.2.18-1.78.33,1.16.21,2.35.69,3.72.13a3.59,3.59,0,0,0,2.22-3.33,2.74,2.74,0,0,1,1.36-2.35A3.24,3.24,0,0,1,197,279c.58-.12,1.18-.18,1.76-.34C197.59,278.43,196.46,278,195.05,278.43ZM71.79,396.22a3.56,3.56,0,0,0-2.32,3.29,2.81,2.81,0,0,1-1.29,2.41,3,3,0,0,1-1.48.48c-.58.12-1.18.18-1.76.34,1.15.2,2.33.69,3.72.15a3.62,3.62,0,0,0,2.2-3.35,2.87,2.87,0,0,1,1.36-2.35,3.05,3.05,0,0,1,1.53-.43c.58-.12,1.17-.2,1.77-.35C74.33,396.22,73.2,395.76,71.79,396.22Zm24.65-62a3.56,3.56,0,0,0-2.32,3.29,2.81,2.81,0,0,1-1.29,2.41,3,3,0,0,1-1.48.48c-.58.12-1.18.18-1.76.34,1.15.2,2.33.69,3.72.15a3.62,3.62,0,0,0,2.2-3.35,2.86,2.86,0,0,1,1.36-2.35,3.05,3.05,0,0,1,1.53-.43c.58-.12,1.17-.2,1.77-.35C99,334.23,97.85,333.76,96.44,334.23Zm119.38,20.84a3.56,3.56,0,0,0-2.32,3.29,2.81,2.81,0,0,1-1.29,2.41,3,3,0,0,1-1.48.48c-.58.12-1.18.18-1.76.34,1.15.2,2.33.69,3.72.15a3.62,3.62,0,0,0,2.2-3.35,2.86,2.86,0,0,1,1.36-2.35,3.05,3.05,0,0,1,1.53-.43c.58-.12,1.17-.2,1.77-.35C218.36,355.07,217.23,354.6,215.82,355.07Zm-85.9-40.7a3.58,3.58,0,0,0-3.92.81,2.84,2.84,0,0,1-2.64.69,3,3,0,0,1-1.36-.77c-.49-.34-1-.7-1.51-1,.7,1,1.18,2.12,2.51,2.78a3.57,3.57,0,0,0,4-.69,2.79,2.79,0,0,1,2.62-.79,2.85,2.85,0,0,1,1.37.7c.5.35,1,.71,1.5,1C131.77,316.14,131.28,315,129.92,314.37Zm64.66,75a3.63,3.63,0,0,0-3.92.83,2.81,2.81,0,0,1-2.62.68,2.85,2.85,0,0,1-1.38-.76c-.49-.33-1-.7-1.5-1,.69,1,1.19,2.11,2.5,2.77a3.58,3.58,0,0,0,4-.69,2.79,2.79,0,0,1,2.62-.78,2.62,2.62,0,0,1,1.37.7c.51.33,1,.71,1.5,1C196.45,391.18,195.94,390,194.58,389.4Zm-2-63.79a3.66,3.66,0,0,0-3.94.81,2.78,2.78,0,0,1-2.62.69,3.15,3.15,0,0,1-1.37-.76c-.5-.33-1-.71-1.5-1,.7,1,1.18,2.11,2.5,2.77a3.55,3.55,0,0,0,4-.69,2.82,2.82,0,0,1,2.6-.79,2.94,2.94,0,0,1,1.4.72c.49.33,1,.7,1.49,1C194.4,327.39,193.91,326.21,192.55,325.61ZM97.17,414.22a3.57,3.57,0,0,0-3.92.81,2.8,2.8,0,0,1-2.62.68,3,3,0,0,1-1.37-.76c-.51-.34-1-.7-1.5-1,.69,1,1.17,2.13,2.5,2.79a3.58,3.58,0,0,0,3.95-.69,2.83,2.83,0,0,1,2.62-.79,2.75,2.75,0,0,1,1.39.7c.51.34,1,.7,1.5,1C99,416,98.53,414.8,97.17,414.22Zm6.27-122.56c-.16.3-.31.6-.46.91a2.89,2.89,0,0,1,1.22.66c.51.35,1,.71,1.49,1A6.84,6.84,0,0,0,103.44,291.66Zm50.78,86a3.58,3.58,0,0,0-3.92.81,2.82,2.82,0,0,1-2.62.69,3.12,3.12,0,0,1-1.38-.76c-.51-.35-1-.71-1.49-1,.68,1,1.16,2.12,2.49,2.78a3.55,3.55,0,0,0,3.95-.69,2.91,2.91,0,0,1,4-.09c.51.35,1,.71,1.5,1C156.07,379.4,155.58,378.22,154.22,377.63Zm4.23-150.15a3.51,3.51,0,0,0-2.26-2c-.44.28-.89.58-1.33.89l-.39.28a3.08,3.08,0,0,0,.61.06,2.83,2.83,0,0,1,2.4,1.28,2.78,2.78,0,0,1,.48,1.49c.13.58.19,1.18.34,1.76C158.5,230.05,159,228.87,158.45,227.48ZM123.68,359.66a3.66,3.66,0,0,0-3.35-2.2A2.79,2.79,0,0,1,118,356.1a3.13,3.13,0,0,1-.45-1.51c-.1-.58-.18-1.18-.33-1.77-.19,1.17-.67,2.32-.19,3.73a3.54,3.54,0,0,0,3.28,2.3,2.9,2.9,0,0,1,2.42,1.31,3,3,0,0,1,.48,1.48c.1.58.18,1.16.34,1.76C123.74,362.24,124.22,361.05,123.68,359.66Zm8.69-78.06a3.61,3.61,0,0,0-3.35-2.2,2.74,2.74,0,0,1-2.34-1.36,3,3,0,0,1-.43-1.51c-.12-.58-.18-1.18-.35-1.78-.19,1.2-.67,2.33-.19,3.74a3.57,3.57,0,0,0,3.29,2.32,2.82,2.82,0,0,1,2.41,1.28,2.92,2.92,0,0,1,.48,1.47c.12.6.18,1.2.34,1.78C132.43,284.19,132.92,283,132.37,281.6Zm79.07-23.24a4.11,4.11,0,0,0,.18,1.84,3.06,3.06,0,0,0,.27.58C211.75,260,211.6,259.16,211.44,258.36Zm-45.07,42.83A3.62,3.62,0,0,0,163,299a2.81,2.81,0,0,1-2.35-1.38,3,3,0,0,1-.41-1.5c-.14-.59-.2-1.18-.36-1.78-.18,1.19-.66,2.34-.18,3.74a3.54,3.54,0,0,0,3.27,2.32,2.83,2.83,0,0,1,2.41,1.28,2.74,2.74,0,0,1,.48,1.48c.12.6.18,1.18.35,1.78C166.41,303.78,166.9,302.56,166.37,301.19Zm48.88,8.56a3.6,3.6,0,0,0-3.34-2.2,2.77,2.77,0,0,1-2.35-1.36,3.09,3.09,0,0,1-.43-1.52c-.12-.57-.18-1.17-.33-1.77-.21,1.18-.69,2.32-.21,3.73a3.57,3.57,0,0,0,3.29,2.32,2.93,2.93,0,0,1,2.9,2.76c.11.6.18,1.2.33,1.77C215.31,312.33,215.8,311.14,215.25,309.75ZM159.31,419.12a3.58,3.58,0,0,0-3.34-2.2,2.79,2.79,0,0,1-2.33-1.37,3.13,3.13,0,0,1-.45-1.51c-.1-.58-.18-1.18-.34-1.76-.2,1.16-.66,2.32-.2,3.72a3.58,3.58,0,0,0,3.31,2.31,2.91,2.91,0,0,1,2.41,1.3,2.65,2.65,0,0,1,.42,1.14h.77A3.54,3.54,0,0,0,159.31,419.12ZM94.62,382a3.58,3.58,0,0,0-3.34-2.2A2.77,2.77,0,0,1,89,378.44a3,3,0,0,1-.45-1.51c-.11-.58-.18-1.18-.34-1.76-.2,1.16-.66,2.32-.2,3.72a3.57,3.57,0,0,0,3.31,2.31,2.91,2.91,0,0,1,2.41,1.3,2.85,2.85,0,0,1,.46,1.48c.14.58.2,1.17.34,1.77C94.69,384.58,95.17,383.4,94.62,382Zm84.27-22.35a3.61,3.61,0,0,0-3.34-2.2,2.78,2.78,0,0,1-2.33-1.36,3,3,0,0,1-.45-1.51c-.11-.58-.18-1.18-.34-1.77-.2,1.17-.66,2.32-.2,3.73a3.56,3.56,0,0,0,3.31,2.3,2.9,2.9,0,0,1,2.41,1.31,2.79,2.79,0,0,1,.46,1.48c.14.58.2,1.16.34,1.76C179,362.24,179.44,361.05,178.89,359.66ZM191,239.23a3.58,3.58,0,0,0-4,.68,2.88,2.88,0,0,1-4,.11c-.5-.34-1-.72-1.51-1,.69,1,1.2,2.14,2.56,2.74a3.59,3.59,0,0,0,3.92-.81,2.78,2.78,0,0,1,2.62-.69A3.2,3.2,0,0,1,192,241c.49.33.95.71,1.48,1C192.82,241,192.34,239.9,191,239.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,251.67c-8.7,0-19.95-15.81-23.19-27.29-.21-.79,9.15-28.09,10.44-33.69.26-1.16,33.22,16.65,33.22,16.65s-6.17,10.94-8.36,20.72C207.93,228.88,204.41,251.62,196,251.67Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.47,207.33s-6.17,10.95-8.37,20.73c0,.2-.27,1.62-.7,3.67-16.36-5.4-24.64-18.11-28.52-26.77,2-6.19,3.85-12,4.37-14.27C183.52,189.54,216.47,207.33,216.47,207.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.6,147.58s9.65,8.39,7.91,20.46-8.33,23.14-9.51,23.39S236.6,147.58,236.6,147.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.9,147.34c-8,10.73-14,47.79-8.22,58.6,8.42,15.68,28.39,24,43.29,12.51,14.44-11.16,21.47-59.59,14.4-70.06C227,133,199.69,131.49,187.9,147.34Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.12,184.42c0-.09.16.17.14.27-.72,2.46-1.12,5.4.92,6.8.06,0,0,.16-.06.13C225.48,190.54,226.05,186.64,227.12,184.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,182.4c4.06.71,2.33,8.8-1.43,8.13S226.59,181.8,230,182.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,203.19c.42.74.77,1.71,1.64,2.05a6.87,6.87,0,0,0,2.82.16.09.09,0,0,1,.07.16A3.44,3.44,0,0,1,206,206a2.73,2.73,0,0,1-1.29-2.74C204.69,203.07,204.89,203.08,205,203.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.62,195.11s-.35,3.84-.77,5.6c0,.16-4.93-1.43-10.49-.9-.83.08-.67-.57.32-.89,2-.63,4.45-1.15,9-.09.24-.46.45-5.93.73-5.88a15.92,15.92,0,0,1,3.78,1.83c1-8,.67-16.06,1.76-24a.25.25,0,0,1,.49,0c.92,8.44,0,17.66-.81,25.93C224.56,197.74,221.26,195.57,220.62,195.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.05,176.68c-1.14.15-2.21.09-3.34.13-1.29,0-2.3.2-3.44-.52a1.73,1.73,0,0,1-.51-2c.74-1.46,2.3-1.89,3.84-2a6.26,6.26,0,0,1,4.36,1.18A1.84,1.84,0,0,1,214.05,176.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.41,172.61a29.74,29.74,0,0,1-2.87-1.71c-1.09-.67-2-1.09-2.6-2.3a1.72,1.72,0,0,1,.69-2c1.41-.81,3-.33,4.3.42a6.27,6.27,0,0,1,3,3.38A1.83,1.83,0,0,1,234.41,172.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.1,180.52a7.8,7.8,0,0,1,2.36-.24,8.46,8.46,0,0,1,2.4.48,7,7,0,0,1,2.19,1.35,6.2,6.2,0,0,1,1.48,2.28l.58,1.56-1.58-.39a15.31,15.31,0,0,0-3.4-.47,6.88,6.88,0,0,0-3.45.73,5.1,5.1,0,0,1,3.32-2,9.75,9.75,0,0,1,3.95.07L212,185a5.9,5.9,0,0,0-2.67-2.9A17.2,17.2,0,0,0,205.1,180.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.84,187.74a14.59,14.59,0,0,0,3.63-.88c.27-.14,1.34-.74,1.31-1a7.26,7.26,0,0,0-.39-1.87,5,5,0,0,1,.76,1.87,2.43,2.43,0,0,1-1.46,1.49A7.19,7.19,0,0,1,208.84,187.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.56,199.68s-3.39,3.71-6.74,3.78c-3.85.08-3.84-3.37.58-4.75C212.71,198,216.56,199.68,216.56,199.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.83,203.45a7.57,7.57,0,0,0,4-1.51c-.61-1.27-2.25-2.8-6.58-1.16C206.5,202.16,207.4,203.51,209.83,203.45Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.35,182.15c4.16,2,11.16-10.35,13.34-15.18,1.93-4.25,5.5-18.12,5.86-19.05s17.12,15.35,28.59,13.8,20.31-10.29,21.16-14.87-11-18.33-22.73-20.72-30,10.2-30,10.2,6.41-5.66,6.31-6.22-8.2,1.33-10.42,6.55c0,0,2.54-6.59,2-6.81s-7.37,4.73-6.7,9.36c0,0-7.76,4.9-9.38,11.32S175.47,179.8,180.35,182.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.3,160.61c-3.58,1-7.18,2.22-11,2.14-4.07-.08-8-1.71-11.55-3.69a37.68,37.68,0,0,1-9.46-7.73c-2.41-2.68-4.43-5.77-7.06-8.24-.65-.61-1.67.32-1.32,1.06,3.44,7.36,10.48,14.14,17.71,17.7,7.61,3.75,15.4,3.1,22.66-1.14C236.37,160.68,236.36,160.6,236.3,160.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.16,180.23s-4.14-14-10.23-12.87-5.62,19.51-.33,23.78a6.48,6.48,0,0,0,9.34-.55Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.2,172.63a.09.09,0,0,0-.09.15c3.66,3.13,4.58,7.8,4.78,12.39-.73-2-2.16-3.42-4.76-2.62-.14,0-.09.25,0,.26a4,4,0,0,1,3.72,2.71,18.9,18.9,0,0,1,.86,4c.08.44.83.47.83,0v-.1C182.49,184.07,180.81,175.11,175.2,172.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.13,209.22a110.42,110.42,0,0,0-7.91,18.07c-.5,1.59-.95,3.18-1.3,4.75,0,.06,0,.21-.08.45,0,.09,0,.2-.06.32-.12.64-.3,1.63-.55,2.85a1.25,1.25,0,0,0,0,.19.19.19,0,0,0,0,.07.22.22,0,0,0,0-.08,71.78,71.78,0,0,1-7.26-35.76l2.34,1.23,1.61.85h0l1.57.83,1.41.74h0l.84.44,1.35.72h0l0,0,1.35.72,1.26.67,1.16.62Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.13,209.21h0a110.42,110.42,0,0,0-7.91,18.07c-.5,1.59-.95,3.18-1.3,4.75,0,.06,0,.21-.08.45,0,.09,0,.2-.06.32-.12.64-.3,1.63-.55,2.85a1.16,1.16,0,0,1,0,.18,71.78,71.78,0,0,1-7.26-35.76l2.34,1.23c.54.28,1.08.56,1.61.85h0l1.57.83,1.41.74h0l.85.46,1.35.72h0l0,0q.71.36,1.35.72l1.26.67,1.16.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.3,143.42s10.63,9.24,8.7,22.53-9.17,25.47-10.46,25.75S242.3,143.42,242.3,143.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.82,188.82v0c-3.22,14.1-8.6,27.26-15.53,32.61a27.52,27.52,0,0,1-15.07,5.84,28.62,28.62,0,0,1-5.63-.17,71.43,71.43,0,0,1-3.66-27,72.18,72.18,0,0,1,3.15-17.32,73.48,73.48,0,0,1,3.3-8.62,1.89,1.89,0,0,1,.06-1.35,3.51,3.51,0,0,1,1.26-1.38,71,71,0,0,1,7.53-11.74c.57-.74,1.16-1.46,1.76-2.16.32-.38.65-.75,1-1.12A72.09,72.09,0,0,1,240.46,141a27,27,0,0,1,2.52,3.11h0l.16.24c1.41,2.09,2.31,5.57,2.74,9.93C246.81,163.41,245.64,176.47,242.82,188.82Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.86,184c0-.1.18.18.15.29-.79,2.71-1.23,5.95,1,7.48.07.05,0,.19-.06.15C230.05,190.72,230.68,186.43,231.86,184Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,181.76c4.47.78,2.57,9.68-1.58,9S231.27,181.1,235,181.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.45,204.65c.46.82.85,1.88,1.81,2.25a7.35,7.35,0,0,0,3.1.18.1.1,0,0,1,.08.18,3.8,3.8,0,0,1-3.87.45,3,3,0,0,1-1.42-3C207.16,204.52,207.38,204.52,207.45,204.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.71,195.75s-.4,4.23-.85,6.17c-.05.18-5.44-1.58-11.55-1-.92.08-.75-.63.34-1,2.18-.7,4.91-1.27,9.94-.1.26-.51.49-6.53.8-6.48a17.4,17.4,0,0,1,4.16,2c1.08-8.79.74-17.68,1.94-26.42a.27.27,0,0,1,.54,0c1,9.3,0,19.44-.89,28.55C229,198.65,225.4,196.26,224.71,195.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.46,175.45a34.54,34.54,0,0,1-3.67.15c-1.42,0-2.54.22-3.78-.57a1.63,1.63,0,0,1-.63-.89,1.89,1.89,0,0,1,.06-1.35,3.51,3.51,0,0,1,1.26-1.38,6.43,6.43,0,0,1,3-.82,6.9,6.9,0,0,1,4.8,1.31A2,2,0,0,1,217.46,175.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.89,171a33.3,33.3,0,0,1-3.16-1.88c-1.21-.74-2.25-1.2-2.86-2.54a1.88,1.88,0,0,1,.75-2.18c1.55-.9,3.25-.37,4.74.46a6.87,6.87,0,0,1,3.31,3.71A2,2,0,0,1,239.89,171Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.61,179.68a8.94,8.94,0,0,1,5.24.27,7.59,7.59,0,0,1,2.42,1.49A6.81,6.81,0,0,1,216.9,184l.64,1.71-1.74-.43a18.52,18.52,0,0,0-3.75-.51,7.61,7.61,0,0,0-3.8.8,5.7,5.7,0,0,1,3.66-2.24,10.42,10.42,0,0,1,4.34.08l-1.09,1.28a6.57,6.57,0,0,0-2.95-3.2A19.63,19.63,0,0,0,207.61,179.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.74,187.63a15.31,15.31,0,0,0,4-1c.3-.14,1.47-.81,1.44-1a8,8,0,0,0-.43-2.07,5.81,5.81,0,0,1,.84,2.06,2.7,2.7,0,0,1-1.61,1.64A7.92,7.92,0,0,1,211.74,187.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.23,200.79s-3.73,4.08-7.42,4.16c-4.24.09-4.23-3.72.63-5.23C216,198.92,220.23,200.79,220.23,200.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.82,204.94a8.52,8.52,0,0,0,4.46-1.66c-.68-1.41-2.48-3.09-7.25-1.28C209.16,203.52,210.15,205,212.82,204.94Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.28,142.62c-.47,2.57-3.24,6.34-7.52,9.64a30.85,30.85,0,0,1-2.87,2,31.2,31.2,0,0,1-4.37,2.31A31.58,31.58,0,0,1,233,159c-3.71.5-7.92-.69-12-2.6A72.09,72.09,0,0,1,240.46,141a70.72,70.72,0,0,1,12.93-5.46C255.47,138.4,256.58,141,256.28,142.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,157.87l-.56.32c-7.46,4.18-15.4,4.91-23.2,1.48.57-.74,1.16-1.46,1.76-2.16a24.38,24.38,0,0,0,9.92,2.61c4,.08,7.77-1.11,11.53-2.2h0l.51-.15C242,157.75,242,157.84,242,157.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.01,
    y: 283.02,
    width: 20.47,
    height: 63.39,
    transform: "translate(375.93 686.67) rotate(-162.68)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.48,121.52a86.55,86.55,0,1,0,56.86,108.39A86.54,86.54,0,0,0,300.48,121.52Zm42.87,104a71.89,71.89,0,1,1-47.23-90A71.9,71.9,0,0,1,343.35,225.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.98 411.11 223.53 420.32 223.53 420.32 251.16 331.71 221.61 322.5 221.61 322.5 193.98 411.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.09,182.76a71.89,71.89,0,1,0,90-47.25A71.89,71.89,0,0,0,206.09,182.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.82,202.84A72,72,0,0,0,272.76,276Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.59,140.88l95.79,100.26a71.91,71.91,0,0,0,7-15.58,70.59,70.59,0,0,0,3.23-19.28l-70.71-74A71.81,71.81,0,0,0,240.59,140.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.57,176l91.24,95.5a73.23,73.23,0,0,0,12.67-6.2l-97.16-101.7A69.16,69.16,0,0,0,208.57,176Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.27,146.14l98.47,103.08c.55-.68,1.09-1.36,1.61-2.06l-98-102.52C233.68,145.12,233,145.61,232.27,146.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.54,136.67l43.71,45.75c-.64-2-1.39-4.08-2.23-6.06l-35.55-37.21Q302.61,137.79,299.54,136.67Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M322.22,219.53c0-.09,0-.18.08-.27.33-1.3-.28,1.29-.1.41.22-1,.43-2.09.6-3.15a67.35,67.35,0,0,0,.83-11.17c0-.53,0-1,0-1.58,0-.17.06,1.25,0,.12,0-.33,0-.65-.06-1-.07-1.24-.19-2.48-.34-3.72a61.91,61.91,0,0,0-1.5-8.09c-.17-.63-.35-1.26-.53-1.9-.23-.85.32,1-.05-.17-.13-.38-.25-.75-.37-1.13-.49-1.42-1-2.82-1.63-4.2s-1.35-3-2.12-4.38c-.35-.66-.72-1.31-1.1-2-.65-1.11.31.45-.2-.33-.25-.37-.49-.75-.73-1.13a61.82,61.82,0,0,0-7.69-9.24c-.06-.06-.58-.56-.15-.15s-.24-.21-.31-.29l-1.33-1.18c-.87-.75-1.75-1.48-2.65-2.19-1.91-1.49-3.9-2.87-5.95-4.17-2.35-1.49-2.68-5.06-1.11-7.2a5.26,5.26,0,0,1,7.2-1.11c13,8.23,23.21,20.44,27.78,35.22a70.91,70.91,0,0,1,2.47,30.74,51.14,51.14,0,0,1-1.38,6.84c-.73,2.6-4.24,4-6.64,3a5.3,5.3,0,0,1-3-6.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.54,233.76a5.07,5.07,0,1,0,6.53-2.94A5.06,5.06,0,0,0,316.54,233.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,235.1c-57.77,39.27-103.16,128.37-82.65,143,18.73,13.33,104.26,24.42,132.57,23.86,8.32-.17,15.54-69.38,6.65-69.22-10.75.2-72.58-5.9-73.62-6.2-2.22-.65,28-54.8,41.36-79.42C184,212.76,162.68,220.35,141,235.1Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.87,351c1.28,6.77-5,10.14-5,10.14s3.84,3.94,3.85,9.23c0,6.05-9.47,8.73-9.47,8.73a18.09,18.09,0,0,1,2.52,10.37c-.58,5.8-9.77,9.86-9.77,9.86a15.89,15.89,0,0,1-3.53,10.52c-6.73,7.67-22.12,5.16-31.92,3.66s-36.18-14.92-41.47-17l9.08-63s45.84-5.78,57.11-2.39C254.75,334,272.43,343.37,273.87,351Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.57,360c-9.36-5.47-19.83-7.86-30.15-10.85a.19.19,0,0,0-.1.36c10.3,2.85,19.89,7.71,30,11A.26.26,0,0,0,268.57,360Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.15,378.21a28.29,28.29,0,0,0-7-2.19q-3.83-.9-7.68-1.68c-5.14-1-10.3-1.95-15.49-2.72-.23,0-.34.31-.1.36,5.12,1,10.23,2.16,15.3,3.42q3.81.94,7.6,2A33.3,33.3,0,0,0,263,378.9.37.37,0,0,0,263.15,378.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.78,399.25c-1.83-1.09-4.39-1.26-6.46-1.63q-3.52-.63-7-1.31c-4.69-.9-9.38-1.8-14-2.87-.24-.05-.34.31-.1.36,4.73,1.11,9.44,2.27,14.18,3.34q3.48.78,7,1.52c2,.42,4.42,1.18,6.45.83A.13.13,0,0,0,255.78,399.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.47,324.36c-.54-.61,29.53-52.57,42.93-80.41s-.51-29.18-27.17-10.21C112.67,254.07,54,315,49.35,372.44c-1.49,18.61,130.38,33.77,130.38,33.77l5.94-76.67S126.3,325.3,125.47,324.36Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.89,359.66a3.61,3.61,0,0,0-3.34-2.2,2.78,2.78,0,0,1-2.33-1.36,3,3,0,0,1-.45-1.51c-.11-.58-.18-1.18-.34-1.77-.2,1.17-.66,2.32-.2,3.73a3.56,3.56,0,0,0,3.31,2.3,2.9,2.9,0,0,1,2.41,1.31,2.79,2.79,0,0,1,.46,1.48c.14.58.2,1.16.34,1.76C179,362.24,179.44,361.05,178.89,359.66ZM74.67,320.32a3.58,3.58,0,0,0-3.34-2.2A2.8,2.8,0,0,1,69,316.76a2.5,2.5,0,0,1-.35-.88c-.23.4-.45.8-.67,1.2a.53.53,0,0,0,0,.12,3.56,3.56,0,0,0,3.31,2.31,2.91,2.91,0,0,1,2.41,1.3,2.85,2.85,0,0,1,.46,1.48c.14.59.2,1.17.35,1.77C74.75,322.89,75.22,321.71,74.67,320.32Zm20,61.69a3.58,3.58,0,0,0-3.34-2.2A2.77,2.77,0,0,1,89,378.44a3,3,0,0,1-.45-1.51c-.11-.58-.18-1.18-.34-1.76-.2,1.16-.66,2.32-.2,3.72a3.57,3.57,0,0,0,3.31,2.31,2.91,2.91,0,0,1,2.41,1.3,2.85,2.85,0,0,1,.46,1.48c.14.58.2,1.17.34,1.77C94.69,384.58,95.17,383.4,94.62,382ZM132.37,281.6a3.61,3.61,0,0,0-3.35-2.2,2.74,2.74,0,0,1-2.34-1.36,3,3,0,0,1-.43-1.51c-.12-.58-.18-1.18-.35-1.78-.19,1.2-.67,2.33-.19,3.74a3.57,3.57,0,0,0,3.29,2.32,2.82,2.82,0,0,1,2.41,1.28,2.92,2.92,0,0,1,.48,1.47c.12.6.18,1.2.34,1.78C132.43,284.19,132.92,283,132.37,281.6Zm-8.69,78.06a3.66,3.66,0,0,0-3.35-2.2A2.79,2.79,0,0,1,118,356.1a3.13,3.13,0,0,1-.45-1.51c-.1-.58-.18-1.18-.33-1.77-.19,1.17-.67,2.32-.19,3.73a3.54,3.54,0,0,0,3.28,2.3,2.9,2.9,0,0,1,2.42,1.31,3,3,0,0,1,.48,1.48c.1.58.18,1.16.34,1.76C123.74,362.24,124.22,361.05,123.68,359.66Zm34.77-132.18a3.6,3.6,0,0,0-3.35-2.18l-.36,0-1.56.82a3.64,3.64,0,0,0,1.9.59,2.83,2.83,0,0,1,2.4,1.28,2.78,2.78,0,0,1,.48,1.49c.13.58.19,1.18.34,1.76C158.5,230.05,159,228.87,158.45,227.48Zm-4.23,150.15a3.58,3.58,0,0,0-3.92.81,2.82,2.82,0,0,1-2.62.69,3.12,3.12,0,0,1-1.38-.76c-.51-.35-1-.71-1.49-1,.68,1,1.16,2.12,2.49,2.78a3.55,3.55,0,0,0,3.95-.69,2.91,2.91,0,0,1,4-.09c.51.35,1,.71,1.5,1C156.07,379.4,155.58,378.22,154.22,377.63Zm-51.07-86.12a3.59,3.59,0,0,0-3.92.81,2.81,2.81,0,0,1-2.62.69,3,3,0,0,1-1.37-.77c-.51-.34-1-.7-1.5-1,.69,1,1.17,2.12,2.5,2.78a3.57,3.57,0,0,0,4-.69,2.82,2.82,0,0,1,2.62-.79,2.87,2.87,0,0,1,1.39.7c.51.35,1,.71,1.49,1C105,293.28,104.51,292.09,103.15,291.51Zm-34.78,64.3a3.6,3.6,0,0,0-3.92.81,2.81,2.81,0,0,1-2.62.69,3,3,0,0,1-1.37-.76c-.51-.35-1-.71-1.5-1,.69,1,1.17,2.12,2.5,2.78a3.55,3.55,0,0,0,3.95-.69,2.84,2.84,0,0,1,2.62-.79,3,3,0,0,1,1.39.7c.51.35,1,.71,1.49,1C70.23,357.58,69.73,356.4,68.37,355.81Zm61.55-41.44a3.58,3.58,0,0,0-3.92.81,2.84,2.84,0,0,1-2.64.69,3,3,0,0,1-1.36-.77c-.49-.34-1-.7-1.51-1,.7,1,1.18,2.12,2.51,2.78a3.57,3.57,0,0,0,4-.69,2.79,2.79,0,0,1,2.62-.79,2.23,2.23,0,0,1,.44.13l.46-.84A3.09,3.09,0,0,0,129.92,314.37ZM96.44,334.23a3.56,3.56,0,0,0-2.32,3.29,2.81,2.81,0,0,1-1.29,2.41,3,3,0,0,1-1.48.48c-.58.12-1.18.18-1.76.34,1.15.2,2.33.69,3.72.15a3.62,3.62,0,0,0,2.2-3.35,2.86,2.86,0,0,1,1.36-2.35,3.05,3.05,0,0,1,1.53-.43c.58-.12,1.17-.2,1.77-.35C99,334.23,97.85,333.76,96.44,334.23ZM128,246.64a3.55,3.55,0,0,0-2.32,3.29,2.89,2.89,0,0,1-2.77,2.89c-.58.12-1.18.18-1.76.34,1.15.2,2.33.69,3.72.15a3.61,3.61,0,0,0,2.2-3.35,2.88,2.88,0,0,1,1.36-2.35,3.05,3.05,0,0,1,1.53-.43c.58-.12,1.17-.19,1.76-.34C130.58,246.64,129.44,246.18,128,246.64Zm-4.37,146.52a3.52,3.52,0,0,0-2.32,3.28,2.67,2.67,0,0,1-.23,1.16l1.35.24a3.29,3.29,0,0,0,.27-1.37,2.86,2.86,0,0,1,1.36-2.35,3.05,3.05,0,0,1,1.53-.42c.58-.13,1.16-.19,1.75-.34C126.21,393.16,125.07,392.67,123.67,393.16Zm27.76-58.92a3.57,3.57,0,0,0-2.32,3.27,2.84,2.84,0,0,1-1.27,2.43,3.13,3.13,0,0,1-1.49.48c-.59.1-1.17.18-1.77.34,1.17.19,2.35.67,3.74.13a3.64,3.64,0,0,0,2.19-3.35,2.81,2.81,0,0,1,1.37-2.33,3,3,0,0,1,1.51-.44c.6-.11,1.17-.19,1.77-.34C154,334.24,152.84,333.76,151.43,334.24Zm9.2-74.91c.32-.61.64-1.21.94-1.81A3.68,3.68,0,0,0,160.63,259.33Zm-2.84,3.52c-.58.11-1.18.18-1.78.35a14.31,14.31,0,0,0,2.4.38c.17-.34.35-.68.53-1A3.29,3.29,0,0,1,157.79,262.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5,325.2c2.52.35,71.58,2.64,86.13,4.89.23,0,.26-.75,0-.78-45-6-83.59-5.75-86.61-5.53C95.46,324,94.79,324.55,99.5,325.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.9,325.13c0-.14,11-20.19,12.18-21.29s3.85-3.69,5-4.9c2.29-2.46,4.42-5,6.62-7.56.18-.21-.13-.51-.31-.31-2.26,2.4-4.74,4.61-7.21,6.77L138.48,301c-.09.06,10.54-19.67,12.27-23.18.13-.26-.14-.43-.3-.23-2.37,3.34-24,42.75-26.66,47.05C123.79,324.67,124.59,324.9,125.9,325.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.48,386.38C92.73,392.68,175,405.3,179.25,406a24.79,24.79,0,0,1,.65-4.49c0-.16.36-.18.37,0a58.46,58.46,0,0,1,.18,6.31c0,.35-81-10.72-109-21.23C71.33,386.54,71.35,386.34,71.48,386.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.48,398.29a158.79,158.79,0,0,0,1.8-15.85q.74-7.8,1.37-15.6c.84-10.49,1.95-21,2.11-31.58a.19.19,0,0,0-.38,0c-1.89,10.45-2.71,21.14-3.63,31.71q-.69,7.95-1.16,15.92a137.35,137.35,0,0,0-.52,15.44C162.08,398.53,162.43,398.5,162.48,398.29Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Globe--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.66,360.85a56.47,56.47,0,0,1-10.83,33.34h0A56.72,56.72,0,1,1,361,304.14q2.32,0,4.62.18a56.47,56.47,0,0,1,24.81,8,57.07,57.07,0,0,1,18.69,18.46A56.5,56.5,0,0,1,417.66,360.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.19,387.62c-.71,1.91.48,2,.56,2.78s0,2.3-2.3,4.61-6.12,1.82-6.92,2.78-2.14,5-4,6.35-2.22.56-4.92,1.11-4.77,4.06-5.56,5.72.16,4.45-1.75,4.53-2.78-4.05-4.53-6.27a15,15,0,0,1-2.86-6.83c-.55-2.63.32-8.11,0-10.25s-6-6-8.1-8.58-4.92-7.86-4.76-9.61a7.06,7.06,0,0,1,2.38-4.37c.95-.72.55-1.11.71-1.75s1-.79,1.12-1.59-.48-3.17-1.28-3.57-1.35.95-1.82.71-1.91-1.9-2.46-2.06-.4,1-1.2-.48-1.19-5.32-1.82-6-1.12,1.12-2.62,0-2.15-3.25-2.78-3.57-1.51.08-2.17-1.19.58-3.58,0-3.34-1.81,2.07-2.12.32,1.58-7.63,1.27-10.8a12.67,12.67,0,0,1,3-9.22s.31-1.74.63-2.86,7.15-5.56,7.94-6.83a6,6,0,0,0,.56-2.26,56.49,56.49,0,0,1,33.59-11q2.32,0,4.62.18a1.16,1.16,0,0,0,.16.21c.68.88,1.43,1.43,3.44,2.18s2.49,1.69,2.06,2.48a2,2,0,0,1-1.9,1c-.8.05-1.54-.37-2.39.16s-1.69,3.39-2.8,3.55-3.07-2.55-3.5-3.34,1-2.49.31-3.28-1.79-.64-3.59-.8-6,.53-5.83,1.22,6.15-.11,6.31,1.27-4.4,3.71-5.19,3.5-1.86-1.59-3-1.75-2.12.79-2.85.9-1.6-.79-2.71-.58-1.38,1.16-2,1.53-2,.37-2.12,1.22,1.75,1.33,2.22,1.85-.58,2.34-.1,2.71,3.44-2.23,4.18-2.86,1.38-3.39,3-3.34,2.12,2.75,2.64,3,1.7-.64,3.45-.27,3,4.19,3.28,5.35,1.06,2.33.42,2.81-3.49-.32-3.86-1.06,1.9-1.85,1.75-2.12a2.31,2.31,0,0,0-2.18-.22c-.68.42-1,1.28-1.74,1.49s-2.7-2-3.23-1.38.53,2.65,1.06,3.13,2.48.74,2.64,1.27-1.32,1.69-3.12,1.59-3.28-1.48-4-.9-.32,2.12-.8,2.65-3.07.16-4.34,1.53-1.85,3.44-3.12,4.61-1.86-.32-3.55,1.32-2,5.3-2,6.57,0,2.28-.43,2.12a3.56,3.56,0,0,1-1.16-2c-.16-.69.37-1.86.37-2.28s-2.44-2.59-3.87-2.81-2.7,1-3.76,1.8-3,.69-3.65,1.38-1.22,6.78-.69,8.21,1.22,1.43,2.91.69.74-2.17,1.75-1.86a2.37,2.37,0,0,1,1.54,2.23c0,.85-2,2.86-1.75,3.44s2-.1,2.86.16,1.27.79,1,3-.11,3.86,1.16,4.58,2-1,2.54-.8,1.35,1.51,2.15,1.43.39-.79,1.9-1.27,1-.79,1.27-1.75a1.75,1.75,0,0,1,2.31-1.27c1,.48.31,1.19.39,2s1.91.87,3.34,1.35,2.22,0,5.08,1,3,3.81,4.21,4.29,5.17-.32,8,1.75,2.06,5.88,3.49,7,6.75,2.62,8.82,3,2.38-1,4.05-.64,2.62.88,3.18,3.18C380.12,381.47,373.91,385.71,373.19,387.62Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.51,347c.05.45,1.38.64,3,1.54s2.17,3.55,3,3.49.58-1.27.9-1.58a1,1,0,0,0,0-1.7c-.85-.69-1.68-2.17-3.22-2.38s-1.82-.85-2.5-.8A1.2,1.2,0,0,0,330.51,347Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.25,351.45c-.24.65,0,1.11,1.69,1.54s3.29-.43,2.76-.77-1.33-.19-1-.77.21-1.43-1.17-1.27S339.46,350.87,339.25,351.45Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.18,351.63c-.58.09-.9,1.09-.32,1.73s.58.53,1.27,0,1.75-.79,1.49-1.32S345.76,351.55,345.18,351.63Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.79,353.8c.26-.8,1.59,0,2.17.83a3.41,3.41,0,0,1,0,3c-.32.91-.53,2-1.27,1.54s.05-1.69-.06-2.44S349.57,354.45,349.79,353.8Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.61,309.62c-.28.66,1,.9,1.75,1.32s1.32.69,1.75,0a1.16,1.16,0,0,0-.75-1.64C374.78,309.14,372.88,309,372.61,309.62Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.62,315.81c.49.52,1.32.43,1.91,1.17s.37,2,1.11,2.38,1.27,0,1.32-.53-1.06-1.85-.95-2.12,1.53.37,1.85,1.17-.32,1.9.43,2.12.58-.74.9-1,1-.1.95-.74a4.79,4.79,0,0,0-1.59-2.49,6.13,6.13,0,0,0-2.38-1.27,3.51,3.51,0,0,0-2.86.43C382.72,315.44,382.32,315.5,382.62,315.81Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.53,325.79a.91.91,0,0,1-.3.56c-1.11.8-2.44-2-4-2.49s-2.22-2.49-2.54-2.06-.21,1-.69,1.69-1.17.53-1.48,1.86,1.48,3.76,1.06,4.55-1,.53-1.81.48-.68.68-1.79.37-.16-1.7-1.91-3.34-2.33-2-2-2.7-.16-1.8.63-1.91,1.43,1.06,2,1.38,1.22-.63,1.27-1.48-1.85-2-2.54-2.67-.74-3-.47-3.53,1.06-.32,1.27-1.48c.12-.69-1-1.83-1.88-2.66A57.22,57.22,0,0,1,405.53,325.79Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.44,373.27c.16-1.69-.69-1.8.16-4.92a9,9,0,0,0-1.54-7.15c-.63-.69-2-.48-3.12.21s-.32,1.22-1.06,1.48-1.48-.16-2.17-.1-1.33,1.79-2.81,1.74-2.43-2.17-3.55-3.68-3.39-2.46-4.13-4.31.69-4.72.37-6.89-1.74-1.69-2-2.91.21-.64.58-1.8-.42-1.8.32-3.81,2.07-3,1.75-3.92-1.32-2.39-1.38-3.44,1-1,3-2.49,2.54-1.38,4.08-.85a21.71,21.71,0,0,0,3.39.95c.9.16,2.12,2.49,2.49,2.39s.42-.8.58-1.8a2.28,2.28,0,0,1,.66-1.15,56.76,56.76,0,0,1-2.24,63.37C412.23,386,413.28,375,413.44,373.27Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.05,360.85c0,5.78.25,11.69,1.84,17.34l.49,2.14.69,2.08,1.41,4.18,1.81,4c.31.66.59,1.35.93,2l1.09,1.92A65.7,65.7,0,0,0,315,408.62l3.24,3.05c1.06,1,2.31,1.85,3.46,2.78a72.32,72.32,0,0,0,7.4,5c1.29.73,2.65,1.35,4,2l2,1c.68.31,1.39.54,2.08.82l4.18,1.57,4.32,1.16,2.16.57,2.21.36,4.42.71,4.47.27,2.24.13c.74,0,1.49,0,2.23-.08l4.48-.19c1.49-.16,3-.42,4.44-.63a71.28,71.28,0,0,0,8.75-2c1.42-.45,2.81-1,4.22-1.5l2.11-.77c.69-.29,1.36-.63,2-.95l4.05-1.94,3.84-2.32a32.31,32.31,0,0,0,3.7-2.54c1.18-.92,2.42-1.76,3.55-2.74a70.3,70.3,0,0,0,6.42-6.26,64.53,64.53,0,0,0,10.16-14.71l1.91-4.05c.58-1.38,1-2.81,1.54-4.2l.75-2.11c.23-.71.38-1.45.57-2.17l1.08-4.34A70.74,70.74,0,0,0,428,356.78a64.89,64.89,0,0,0-38.76-54.9,66.43,66.43,0,0,1,25.24,23A65,65,0,0,1,424.79,357a72.64,72.64,0,0,1-1.39,16.85l-1.09,4.09c-.2.68-.34,1.37-.57,2l-.75,2c-.51,1.31-.95,2.66-1.52,3.94l-1.86,3.79a32.29,32.29,0,0,1-2.09,3.66c-.76,1.18-1.4,2.45-2.26,3.56a62,62,0,0,1-5.31,6.55,65.63,65.63,0,0,1-6.06,5.85c-1.07.92-2.24,1.7-3.36,2.55l-1.69,1.26c-.57.41-1.19.74-1.78,1.11-18.9,12.42-44.48,13.08-64.45,2.41a69.15,69.15,0,0,1-13.77-9.91A64.08,64.08,0,0,1,306,393.5l-1.16-1.8c-.37-.61-.66-1.27-1-1.9l-2-3.82-1.59-4-.79-2-.59-2.07c-.39-1.38-.81-2.76-1.17-4.16l-.77-4.26c-.13-.71-.28-1.42-.39-2.13l-.18-2.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.73 309.52 391.4 313.17 396.82 296.98 392.87 295.1 383.73 309.52",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.95,
    y: 426.1,
    width: 8.24,
    height: 20.18,
    transform: "translate(720.14 872.38) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.87,
    y: 438.77,
    width: 60.4,
    height: 7.49,
    transform: "translate(720.14 885.03) rotate(180)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.15,127.18a35.14,35.14,0,0,0,58.72,22.23L161.45,152l-8.8-15.2a35.15,35.15,0,1,0-67.5-9.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.67,98.16a35,35,0,0,1,29.44-9.77,35.52,35.52,0,0,1,15,5.62,36.09,36.09,0,0,1,11,11.72,35.54,35.54,0,0,1,2.16,31.32l0-.6L162,151.68l.65,1.12-1.27-.19-17.57-2.7.42-.13a35.55,35.55,0,0,1-17.39,8.59,30.45,30.45,0,0,1-4.86.5,35.27,35.27,0,0,1-22.82-7.07,38.24,38.24,0,0,1-3.71-3.14A39.51,39.51,0,0,1,92.25,145a35.33,35.33,0,0,1,3.42-46.84Zm-3.32,46.76a40.72,40.72,0,0,0,3.2,3.63,37.74,37.74,0,0,0,3.71,3.09,32.34,32.34,0,0,0,8.48,4.57,34.71,34.71,0,0,0,9.38,2.07,33.58,33.58,0,0,0,4.81,0,31.87,31.87,0,0,0,4.77-.58A34.61,34.61,0,0,0,143.52,149l.18-.16.24,0,17.6,2.46-.63.93-8.85-15.17-.17-.28.13-.32a35.12,35.12,0,0,0,2.47-15.31A34.76,34.76,0,0,0,150,106.36a36.15,36.15,0,0,0-10.51-11.47A34.55,34.55,0,0,0,125,89.15a35,35,0,0,0-15.62,1.18,34.73,34.73,0,0,0-17,54.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.34,128.36v3.7a2.72,2.72,0,0,1-2.79,2.79,2.79,2.79,0,0,1-2.79-2.79v-5.91c0-.06.06-.06.06-.12s-.06-.06-.06-.11a2.87,2.87,0,0,1,2.79-2.79,6.38,6.38,0,1,0,0-12.75,6.3,6.3,0,0,0-5.47,3.13,2.8,2.8,0,0,1-3.87,1,2.76,2.76,0,0,1-1-3.81,12,12,0,1,1,13.09,17.64Zm0,12.47v1a2.72,2.72,0,0,1-2.79,2.79,2.79,2.79,0,0,1-2.79-2.79v-1a2.83,2.83,0,0,1,2.79-2.79A2.76,2.76,0,0,1,121.34,140.83Z",
    style: {
      fill: "#FFC727"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationNotFound);
export default __webpack_public_path__ + "static/media/locationNotFound.a92a11d6824dee0d6052f5d829197316.svg";
export { ForwardRef as ReactComponent };